import { Space, Typography } from "antd";
import { FilterLoadMore } from "components/CustomFilterMenu";
import CustomTextHiddenLine from "components/CustomTextHiddenLine";
import { useGetProductsLoadMore } from "hooks/serial";
import { useState } from "react";
import "./index.scss";

function FilterProductIDs({ onFilter }) {
  const [params, setParams] = useState({
    filters: { query: undefined },
    pagination: { offset: 0, limit: 10 },
  });

  const { data, onLoadMoreData, hasMoreData } = useGetProductsLoadMore(params, "cache-first");

  const options = data?.map((item) => {
    return {
      value: item?.id,
      label: (
        <Space direction="vertical" className="space-product">
          {/* khong can redirect link */}
          <CustomTextHiddenLine line={1} text={<Typography.Link strong>{item?.code}</Typography.Link>} />
          <CustomTextHiddenLine line={2} text={item?.name} />
        </Space>
      ),
    };
  });

  const handleSearch = (value) => {
    setParams({
      ...params,
      filters: { ...params?.filters, query: value || undefined },
      pagination: { offset: 0, limit: 10 },
    });
  };

  return (
    <FilterLoadMore
      params={params}
      data={options || []}
      onLoadMoreData={onLoadMoreData}
      onFilter={(value) => onFilter(value, "productIDs")}
      onSearchTextChange={handleSearch}
      hasMore={hasMoreData}
    />
  );
}

export default FilterProductIDs;
